<div class="product-col zoom" [attr.aria-busy]="loading">
  <div class="category-card-loading" data-testid="category-card-loading" role="status" aria-live="polite" *ngIf="loading">
    <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
    <span>Opening pricelist...</span>
  </div>
  <a class="featured-image-link" *ngIf="routerLink" [routerLink]="routerLink">
    <span class="sr-only">{{ category.name }}</span>
    <div class="thumb">
      <div class="thumb-image">
        <div class="featured-image" [ngClass]="{ contain: imageContain }" [lazyLoad]="getImage(category.image)" [offset]="600"></div>
      </div>
    </div>
    <div class="thumb-info">
      <div class="thumb-title">
        <div class="thumb-name">
          <h2>
            {{ category.name }}
          </h2>
        </div>
      </div>
    </div>
  </a>
  <a class="featured-image-link" *ngIf="!routerLink" [href]="link" [target]="newWindow ? '_blank' : '_self'" (click)="onLinkClick($event)">
    <span class="sr-only">{{ category.name }}</span>
    <div class="thumb">
      <div class="thumb-image">
        <div class="featured-image" [ngClass]="{ contain: imageContain }" [lazyLoad]="getImage(category.image)" [offset]="600"></div>
      </div>
    </div>
    <div class="thumb-info">
      <div class="thumb-title">
        <div class="thumb-name">
          <h2>
            {{ category.name }}
          </h2>
        </div>
      </div>
    </div>
  </a>
</div>
